import React, { useState, useEffect } from 'react'
import { Tabs, Button } from 'antd'
import FileSaver from 'file-saver'
import XLSX from 'sheetjs-style'
import NetworkService from '../services/NetworkService'
import AnotherTable from '../components/AnotherTable'
import jsPDF from 'jspdf'
import "react-pdf/dist/esm/Page/TextLayer.css";

import { useAtom } from 'jotai'
import { pickedTable, accessTokenAtom } from "../atoms";
import { businessCC, residentialCC, residentialRerun, businessRerun } from '../assets/IssuedCerts'
import RerunTable from '../components/RerunTable'
import { useMsal, useAccount } from "@azure/msal-react";
import { loginRequest } from '../authConfig';


function IssuedTable() {
  const [accessAtom, setAPIAtom] = useAtom(accessTokenAtom)
  const [currentTabTitle, setCurrentTabTitle] = useState('Residential CC Cert Issued')
  const [currentTab, setCurrentTab] = useAtom(pickedTable)
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ccResidentialData, setResidentialCCData] = useState([]);
  const [ccBusinessData, setBusinessCCData] = useState([]);
  const [ccSMBData, setSMBCCData] = useState([]);
  const [residentialRECData, setResidentialREC] = useState([]);
  const [businessRECData, setBusinessREC] = useState([]);
  const [smbRECData, setSMBREC] = useState([]);
  const [businessSGRECData, setBusinessSGREC] = useState([]);
  const [adHocData, setAdHocData] = useState([]);
  const [failedData, setFailedData] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();


  useEffect(() => {
    async function getData() {
      if (account) {
        instance.acquireTokenSilent({
          ...loginRequest,
          account: account,
        })
          .then((response) => {
            console.log('CH', response)

            setAccessToken(response.accessToken)
            return response.accessToken
          }).then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj.getAllCertificatesService(token).then(res => {
              setResidentialCCData([...ccResidentialData, res.data.filter(x => (x.typeOfGreenInstrument == "CC" && x.customerType == "Residential User"))]);
              setBusinessCCData([...ccBusinessData, res.data.filter(x => (x.typeOfGreenInstrument == "CC" && x.customerType == "Business User"))]);
              setSMBCCData([...ccSMBData, res.data.filter(x => (x.typeOfGreenInstrument == "CC" && x.customerType == "SMB User"))]);
              setResidentialREC([...residentialRECData, res.data.filter(x => (x.typeOfGreenInstrument == "REC" && x.customerType == "Residential User"))]);
              setBusinessREC([...businessRECData, res.data.filter(x => (x.typeOfGreenInstrument == "REC" && x.customerType == "Business User"))]);
              setSMBREC([...smbRECData, res.data.filter(x => (x.typeOfGreenInstrument == "REC" && x.customerType == "SMB User"))]);
              setBusinessSGREC([...businessSGRECData, res.data.filter(x => (x.typeOfGreenInstrument == "SGREC" && x.customerType == "Business User"))]);
              setCurrentData(res.data)
            }).then(() => {
              networkServiceObj.getAllAdHocCertificatesService(token).then(res => {
                setAdHocData([...adHocData, res.data]);
              })
            }).then(() => {
              setLoading(false)
            })
          })
      }
    }
    setLoading(true);
    getData();
  }, [])

  const getFailed = (user) => {
    const networkServiceObj = new NetworkService();

    let input;

    input = {
      customerType: user,
      retirementType: null,
      status: "Failed",
    }

    networkServiceObj.getAllCertificatesByService(input, accessToken).then(res => {
      if (res.data != null) {
        setFailedData([res.data])
        setCurrentData(res.data)
      } else {
        setFailedData([]);
      }
    }).then(() => {
      setLoading(false)
    })
  }

  const handleTabChange = (key) => {
    const currentTab = anotherTab.find(t => t.key === key)
    if (!currentTab) return
    const tabLabel = currentTab.label

    if (tabLabel == "Residential Cert Failed to Issue") {
      getFailed("Residential User");
    } else if (tabLabel == "(C&I) Cert Failed to Issue") {
      getFailed("Business User");
    } else if (tabLabel == "SMB Cert Failed to Issue") {
      getFailed("SMB User");
    }
    setCurrentTabTitle(tabLabel)
  }

  const handleExportExcel = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx'

    const dateToday = getDateToday();
    const fileName = `${currentTabTitle}_${dateToday}`
    const cols = getColumns();
    const innerHTML = document.querySelector('.test-data').innerHTML
    const currentTableData = JSON.parse(innerHTML)

    let editedTableData = currentTableData.map(obj => {
      const updatedObject = {};
      cols.forEach(obj2 => {
        if (obj2.header != "Table Operation") {
          let data = obj[obj2.dataKey];
          if (isIsoDate(data)) {
            const date = new Date(data);
            // Get the day, month, and year from the date object
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
            const year = date.getFullYear().toString();
            data = `${day}-${month}-${year}`
          }
          updatedObject[obj2.header] = data;
        }
      })
      return updatedObject
    })

    const ws = XLSX.utils.json_to_sheet(editedTableData)

    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] }
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getColumns = () => {
    switch (currentTabTitle) {
      case 'Residential CC Cert Issued':
        return residentialCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'Residential REC Cert Issued':
        return residentialCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'Residential Cert Failed to Issue':
        return residentialRerun.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'SMB CC Cert Issued':
        return residentialCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'SMB REC Cert Issued':
        return residentialCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'SMB Cert Failed to Issue':
        return residentialRerun.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case '(C&I) CC Cert Issued':
        return businessCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case '(C&I) REC Cert Issued':
        return businessCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case '(C&I) SG REC Cert Issued':
        return businessCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case '(C&I) Cert Failed to Issue':
        return businessRerun.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      case 'Ad-hoc Cert Issued':
        return residentialCC.map(c => ({ header: c.title, dataKey: c.dataIndex }))
        break;
      default:
        return null;
        break;
    }
  }

  const getDateToday = () => {
    var date = new Date();

    // Get day, month, and year components from the Date object
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    var formattedDate = day + '' + month + '' + (year);

    return formattedDate
  }

  function isIsoDate(str) {
    return ((/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{0,3}$/.test(str)) || (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)))
  }

  // Currently, there is only 1 dummy data (and 1 default column). 
  // Meaning, regardless of which Tab is opened, whatever is 
  // displayed in the table will be exported INCLUDING all the Object 
  // keys found in the dummy data.
  const handleExportPdf = () => {
    const innerHTML = document.querySelector('.test-data').innerHTML
    const dateToday = getDateToday();
    const fileName = `${currentTabTitle}_${dateToday}`
    const currentTableData = JSON.parse(innerHTML)

    const newData = currentTableData.map((data) => {
      for (const property in data) {
        if (isIsoDate(data[property])) {
          const date = new Date(data[property]);
          // Get the day, month, and year from the date object
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
          const year = date.getFullYear().toString();
          data[property] = `${day}-${month}-${year}`
        }
      }
      return data
    })

    const width = 1400
    const height = 581.703125
    require('jspdf-autotable')
    const report = new jsPDF('landscape', 'pt', 'a3');
    // get all the header columns of the table
    // do not include the "Tabe Operation" column
    // const cols = activeCC.map(c => ({ title: c.title }))
    const cols2 = getColumns()
    const indexOfObject = cols2.findIndex(object => {
      return object.header === 'Table Operation';
    });
    if (cols2.find(e => e.header === 'Table Operation')) { cols2.splice(indexOfObject, 1); }
    // Flatten each object's values
    // do not include the first element, "key"
    const temp = currentTableData.map(d => {
      const x = Object.values(d)
      return x
    })

    const xOffset = report.internal.pageSize.width / 2
    report.text(currentTabTitle, xOffset, 25, { align: 'center' });
    report.autoTable({
      // tableWidth:'wrap',
      body: newData,
      columns: cols2,
      columnStyles: (currentTabTitle == "Active CC" || currentTabTitle == "Active REC" || currentTabTitle == "Active SG REC") ? {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 'auto' },
        4: { cellWidth: 'auto' },
        5: { cellWidth: 'auto' },
        6: { cellWidth: 200 },
        7: { cellWidth: 250 },
        8: { cellWidth: 'auto' },
        9: { cellWidth: 'auto' },
        10: { cellWidth: 'auto' },
      } : {
        10: { cellWidth: 150 }
      }
    })
    report.save(fileName + '.pdf')
  }

  const anotherTab = [
    {
      key: 1,
      label: 'Residential CC Cert Issued',
      children: <AnotherTable dummyData={ccResidentialData[0] == null ? [] : ccResidentialData[0]} defaultColumns={residentialCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 2,
      label: 'Residential REC Cert Issued',
      children: <AnotherTable dummyData={residentialRECData[0] == null ? [] : residentialRECData[0]} defaultColumns={residentialCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 3,
      label: 'Residential Cert Failed to Issue',
      children: <RerunTable dummyData={failedData[0] == null ? [] : failedData[0]} defaultColumns={residentialRerun} token={accessToken}></RerunTable>,
    },
    {
      key: 9,
      label: 'SMB CC Cert Issued',
      children: <AnotherTable dummyData={ccSMBData[0] == null ? [] : ccSMBData[0]} defaultColumns={residentialCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 10,
      label: 'SMB REC Cert Issued',
      children: <AnotherTable dummyData={smbRECData[0] == null ? [] : smbRECData[0]} defaultColumns={residentialCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 11,
      label: 'SMB Cert Failed to Issue',
      children: <RerunTable dummyData={failedData[0] == null ? [] : failedData[0]} defaultColumns={residentialRerun} token={accessToken}></RerunTable>,
    },
    {
      key: 4,
      label: '(C&I) CC Cert Issued',
      children: <AnotherTable dummyData={ccBusinessData[0] == null ? [] : ccBusinessData[0]} defaultColumns={businessCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 5,
      label: '(C&I) REC Cert Issued',
      children: <AnotherTable dummyData={businessRECData[0] == null ? [] : businessRECData[0]} defaultColumns={businessCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 6,
      label: '(C&I) SG REC Cert Issued',
      children: <AnotherTable dummyData={businessSGRECData[0] == null ? [] : businessSGRECData[0]} defaultColumns={businessCC} radio={false} token={accessToken}></AnotherTable>,
    },
    {
      key: 7,
      label: '(C&I) Cert Failed to Issue',
      children: <RerunTable dummyData={failedData[0] == null ? [] : failedData[0]} defaultColumns={businessRerun} token={accessToken}></RerunTable>,
    },
    {
      key: 8,
      label: 'Ad-hoc Cert Issued',
      children: <AnotherTable dummyData={adHocData[0] == null ? [] : adHocData[0]} defaultColumns={residentialCC} radio={false} token={accessToken}></AnotherTable>,
    }
  ]


  return (
    <div className="App">

      <div className='row' style={{ width: '100%' }}>
        {}

        <div className="col d-flex justify-content-end">
          <Button key="excel" onClick={() => handleExportExcel('excelData')}>
            Export Excel
          </Button>
          <Button key="pdf" onClick={() => handleExportPdf('pdfData')}>
            Export PDF
          </Button>
        </div>
      </div>

      {loading == false && <Tabs defaultActiveKey='1' items={anotherTab} onChange={handleTabChange} destroyInactiveTabPane={true}></Tabs>}

    </div>
  )
}

export default IssuedTable
